import React from 'react';
interface CustomTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: string;
  formatter?: (value: number) => string;
}
export const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
  formatter = value => `${value.toLocaleString()}`
}) => {
  if (!active || !payload?.length) return null;
  return <div className="bg-white p-3 shadow-lg rounded-lg border border-gray-100" data-id="element-30">
      <p className="text-sm font-medium text-gray-600 mb-2" data-id="element-31">{label}</p>
      {payload.map((entry, index) => <div key={index} className="flex items-center text-sm" data-id="element-32">
          <div className="w-2 h-2 rounded-full mr-2" style={{
        backgroundColor: entry.color
      }} data-id="element-33" />
          <span className="text-gray-600" data-id="element-34">{entry.name}: </span>
          <span className="font-medium ml-1" data-id="element-35">{formatter(entry.value)}</span>
        </div>)}
    </div>;
};